import { useState } from 'react';
import type { MusicVibeSharing } from '../music/types';

export const MUSIC_HEAT_K_ANONYMITY_THRESHOLD_PUBLIC = 20;

export interface MusicVibeConsentDialogProps {
    target: Exclude<MusicVibeSharing, 'off'>;
    onClose: (chosen: MusicVibeSharing | null) => void | Promise<void>;
}

export function MusicVibeConsentDialog({ target, onClose }: MusicVibeConsentDialogProps) {
    const [step, setStep] = useState<1 | 2>(1);

    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-text/30 p-4">
            <div className="bg-surface rounded-lg border border-line shadow-xl w-full max-w-md p-4">
                {step === 1 ? (
                    <>
                        <h3 className="font-semibold mb-2">Share what you're vibing on at places?</h3>
                        <p className="muted text-sm mb-4">
                            Your Pal can attach the kind of music you're listening to, like lofi or hiphop,
                            to Echoes you save at venues. No song titles, no artists, no app names ever leave
                            your device. Aggregated with at least 3 other Pals.
                        </p>
                        <div className="flex gap-2 justify-end">
                            <button className="btn-secondary" onClick={() => void onClose(null)}>Not now</button>
                            <button
                                className="btn-primary"
                                onClick={() => target === 'places_only' ? void onClose('places_only') : setStep(2)}
                            >
                                Share at places
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 className="font-semibold mb-2">Also share music vibe along routes?</h3>
                        <p className="muted text-sm mb-4">
                            This is a coarser location signal. Your device samples genre roughly every 3 minutes
                            while driving, aggregated into 5 km cells with at least {MUSIC_HEAT_K_ANONYMITY_THRESHOLD_PUBLIC} other
                            Pals before anything is visible.
                        </p>
                        <div className="flex gap-2 justify-end">
                            <button className="btn-secondary" onClick={() => void onClose('places_only')}>
                                Just at places
                            </button>
                            <button className="btn-primary" onClick={() => void onClose('places_and_routes')}>
                                Share along routes too
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
